// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/notification.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { AgentMode } from "./agent_pb";
import { file_gitpod_v1_agent } from "./agent_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/notification.proto.
 */
export const file_gitpod_v1_notification: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_v1_agent, file_gitpod_v1_pagination, file_google_protobuf_timestamp]);

/**
 * Notification represents an in-app notification for a user.
 *
 * @generated from message gitpod.v1.Notification
 */
export type Notification = Message<"gitpod.v1.Notification"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: gitpod.v1.NotificationType type = 3;
   */
  type: NotificationType;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string body = 5;
   */
  body: string;

  /**
   * @generated from field: gitpod.v1.NotificationContext context = 6;
   */
  context?: NotificationContext;

  /**
   * @generated from field: google.protobuf.Timestamp read_at = 7;
   */
  readAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 0);

/**
 * NotificationContext carries structured metadata for click-through navigation.
 * Context is snapshotted at emit time so deleted resources still have display names.
 *
 * @generated from message gitpod.v1.NotificationContext
 */
export type NotificationContext = Message<"gitpod.v1.NotificationContext"> & {
  /**
   * @generated from oneof gitpod.v1.NotificationContext.context
   */
  context: {
    /**
     * @generated from field: gitpod.v1.NotificationContext.EnvironmentContext environment = 1;
     */
    value: NotificationContext_EnvironmentContext;
    case: "environment";
  } | {
    /**
     * @generated from field: gitpod.v1.NotificationContext.AgentExecutionContext agent_execution = 2;
     */
    value: NotificationContext_AgentExecutionContext;
    case: "agentExecution";
  } | {
    /**
     * @generated from field: gitpod.v1.NotificationContext.ProjectContext project = 3;
     */
    value: NotificationContext_ProjectContext;
    case: "project";
  } | {
    /**
     * @generated from field: gitpod.v1.NotificationContext.WorkflowExecutionContext workflow_execution = 4;
     */
    value: NotificationContext_WorkflowExecutionContext;
    case: "workflowExecution";
  } | {
    /**
     * @generated from field: gitpod.v1.NotificationContext.MemberContext member = 5;
     */
    value: NotificationContext_MemberContext;
    case: "member";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.NotificationContext.
 * Use `create(NotificationContextSchema)` to create a new message.
 */
export const NotificationContextSchema: GenMessage<NotificationContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 1);

/**
 * @generated from message gitpod.v1.NotificationContext.EnvironmentContext
 */
export type NotificationContext_EnvironmentContext = Message<"gitpod.v1.NotificationContext.EnvironmentContext"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;
};

/**
 * Describes the message gitpod.v1.NotificationContext.EnvironmentContext.
 * Use `create(NotificationContext_EnvironmentContextSchema)` to create a new message.
 */
export const NotificationContext_EnvironmentContextSchema: GenMessage<NotificationContext_EnvironmentContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 1, 0);

/**
 * @generated from message gitpod.v1.NotificationContext.AgentExecutionContext
 */
export type NotificationContext_AgentExecutionContext = Message<"gitpod.v1.NotificationContext.AgentExecutionContext"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: string agent_execution_id = 2;
   */
  agentExecutionId: string;

  /**
   * @generated from field: string agent_execution_name = 3;
   */
  agentExecutionName: string;

  /**
   * @generated from field: gitpod.v1.AgentMode mode = 4;
   */
  mode: AgentMode;
};

/**
 * Describes the message gitpod.v1.NotificationContext.AgentExecutionContext.
 * Use `create(NotificationContext_AgentExecutionContextSchema)` to create a new message.
 */
export const NotificationContext_AgentExecutionContextSchema: GenMessage<NotificationContext_AgentExecutionContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 1, 1);

/**
 * @generated from message gitpod.v1.NotificationContext.ProjectContext
 */
export type NotificationContext_ProjectContext = Message<"gitpod.v1.NotificationContext.ProjectContext"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string project_name = 2;
   */
  projectName: string;
};

/**
 * Describes the message gitpod.v1.NotificationContext.ProjectContext.
 * Use `create(NotificationContext_ProjectContextSchema)` to create a new message.
 */
export const NotificationContext_ProjectContextSchema: GenMessage<NotificationContext_ProjectContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 1, 2);

/**
 * @generated from message gitpod.v1.NotificationContext.WorkflowExecutionContext
 */
export type NotificationContext_WorkflowExecutionContext = Message<"gitpod.v1.NotificationContext.WorkflowExecutionContext"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: string workflow_execution_id = 2;
   */
  workflowExecutionId: string;

  /**
   * @generated from field: string workflow_name = 3;
   */
  workflowName: string;
};

/**
 * Describes the message gitpod.v1.NotificationContext.WorkflowExecutionContext.
 * Use `create(NotificationContext_WorkflowExecutionContextSchema)` to create a new message.
 */
export const NotificationContext_WorkflowExecutionContextSchema: GenMessage<NotificationContext_WorkflowExecutionContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 1, 3);

/**
 * @generated from message gitpod.v1.NotificationContext.MemberContext
 */
export type NotificationContext_MemberContext = Message<"gitpod.v1.NotificationContext.MemberContext"> & {
  /**
   * @generated from oneof gitpod.v1.NotificationContext.MemberContext.target
   */
  target: {
    /**
     * @generated from field: gitpod.v1.NotificationContext.MemberContext.Group group = 1;
     */
    value: NotificationContext_MemberContext_Group;
    case: "group";
  } | {
    /**
     * @generated from field: gitpod.v1.NotificationContext.MemberContext.Team team = 2;
     */
    value: NotificationContext_MemberContext_Team;
    case: "team";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.NotificationContext.MemberContext.
 * Use `create(NotificationContext_MemberContextSchema)` to create a new message.
 */
export const NotificationContext_MemberContextSchema: GenMessage<NotificationContext_MemberContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 1, 4);

/**
 * @generated from message gitpod.v1.NotificationContext.MemberContext.Group
 */
export type NotificationContext_MemberContext_Group = Message<"gitpod.v1.NotificationContext.MemberContext.Group"> & {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId: string;

  /**
   * @generated from field: string group_name = 2;
   */
  groupName: string;
};

/**
 * Describes the message gitpod.v1.NotificationContext.MemberContext.Group.
 * Use `create(NotificationContext_MemberContext_GroupSchema)` to create a new message.
 */
export const NotificationContext_MemberContext_GroupSchema: GenMessage<NotificationContext_MemberContext_Group> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 1, 4, 0);

/**
 * @generated from message gitpod.v1.NotificationContext.MemberContext.Team
 */
export type NotificationContext_MemberContext_Team = Message<"gitpod.v1.NotificationContext.MemberContext.Team"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string team_name = 2;
   */
  teamName: string;
};

/**
 * Describes the message gitpod.v1.NotificationContext.MemberContext.Team.
 * Use `create(NotificationContext_MemberContext_TeamSchema)` to create a new message.
 */
export const NotificationContext_MemberContext_TeamSchema: GenMessage<NotificationContext_MemberContext_Team> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 1, 4, 1);

/**
 * @generated from message gitpod.v1.ListNotificationsRequest
 */
export type ListNotificationsRequest = Message<"gitpod.v1.ListNotificationsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Filter by read status. If not set, returns all notifications.
   *
   * @generated from field: optional bool read = 2;
   */
  read?: boolean;

  /**
   * Filter by notification types. If empty, returns all types.
   *
   * @generated from field: repeated gitpod.v1.NotificationType types = 3;
   */
  types: NotificationType[];
};

/**
 * Describes the message gitpod.v1.ListNotificationsRequest.
 * Use `create(ListNotificationsRequestSchema)` to create a new message.
 */
export const ListNotificationsRequestSchema: GenMessage<ListNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 2);

/**
 * @generated from message gitpod.v1.ListNotificationsResponse
 */
export type ListNotificationsResponse = Message<"gitpod.v1.ListNotificationsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Notification notifications = 2;
   */
  notifications: Notification[];

  /**
   * Counts for the inbox badge. Always returned regardless of filters.
   *
   * @generated from field: int32 unread_count = 3;
   */
  unreadCount: number;

  /**
   * @generated from field: int32 total_count = 4;
   */
  totalCount: number;
};

/**
 * Describes the message gitpod.v1.ListNotificationsResponse.
 * Use `create(ListNotificationsResponseSchema)` to create a new message.
 */
export const ListNotificationsResponseSchema: GenMessage<ListNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 3);

/**
 * @generated from message gitpod.v1.GetNotificationRequest
 */
export type GetNotificationRequest = Message<"gitpod.v1.GetNotificationRequest"> & {
  /**
   * @generated from field: string notification_id = 1;
   */
  notificationId: string;
};

/**
 * Describes the message gitpod.v1.GetNotificationRequest.
 * Use `create(GetNotificationRequestSchema)` to create a new message.
 */
export const GetNotificationRequestSchema: GenMessage<GetNotificationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 4);

/**
 * @generated from message gitpod.v1.GetNotificationResponse
 */
export type GetNotificationResponse = Message<"gitpod.v1.GetNotificationResponse"> & {
  /**
   * @generated from field: gitpod.v1.Notification notification = 1;
   */
  notification?: Notification;
};

/**
 * Describes the message gitpod.v1.GetNotificationResponse.
 * Use `create(GetNotificationResponseSchema)` to create a new message.
 */
export const GetNotificationResponseSchema: GenMessage<GetNotificationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 5);

/**
 * @generated from message gitpod.v1.MarkNotificationsReadRequest
 */
export type MarkNotificationsReadRequest = Message<"gitpod.v1.MarkNotificationsReadRequest"> & {
  /**
   * @generated from field: repeated string notification_ids = 1;
   */
  notificationIds: string[];
};

/**
 * Describes the message gitpod.v1.MarkNotificationsReadRequest.
 * Use `create(MarkNotificationsReadRequestSchema)` to create a new message.
 */
export const MarkNotificationsReadRequestSchema: GenMessage<MarkNotificationsReadRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 6);

/**
 * @generated from message gitpod.v1.MarkNotificationsReadResponse
 */
export type MarkNotificationsReadResponse = Message<"gitpod.v1.MarkNotificationsReadResponse"> & {
};

/**
 * Describes the message gitpod.v1.MarkNotificationsReadResponse.
 * Use `create(MarkNotificationsReadResponseSchema)` to create a new message.
 */
export const MarkNotificationsReadResponseSchema: GenMessage<MarkNotificationsReadResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 7);

/**
 * @generated from message gitpod.v1.MarkNotificationsUnreadRequest
 */
export type MarkNotificationsUnreadRequest = Message<"gitpod.v1.MarkNotificationsUnreadRequest"> & {
  /**
   * @generated from field: repeated string notification_ids = 1;
   */
  notificationIds: string[];
};

/**
 * Describes the message gitpod.v1.MarkNotificationsUnreadRequest.
 * Use `create(MarkNotificationsUnreadRequestSchema)` to create a new message.
 */
export const MarkNotificationsUnreadRequestSchema: GenMessage<MarkNotificationsUnreadRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 8);

/**
 * @generated from message gitpod.v1.MarkNotificationsUnreadResponse
 */
export type MarkNotificationsUnreadResponse = Message<"gitpod.v1.MarkNotificationsUnreadResponse"> & {
};

/**
 * Describes the message gitpod.v1.MarkNotificationsUnreadResponse.
 * Use `create(MarkNotificationsUnreadResponseSchema)` to create a new message.
 */
export const MarkNotificationsUnreadResponseSchema: GenMessage<MarkNotificationsUnreadResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 9);

/**
 * @generated from message gitpod.v1.DeleteNotificationsRequest
 */
export type DeleteNotificationsRequest = Message<"gitpod.v1.DeleteNotificationsRequest"> & {
  /**
   * @generated from field: repeated string notification_ids = 1;
   */
  notificationIds: string[];
};

/**
 * Describes the message gitpod.v1.DeleteNotificationsRequest.
 * Use `create(DeleteNotificationsRequestSchema)` to create a new message.
 */
export const DeleteNotificationsRequestSchema: GenMessage<DeleteNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 10);

/**
 * @generated from message gitpod.v1.DeleteNotificationsResponse
 */
export type DeleteNotificationsResponse = Message<"gitpod.v1.DeleteNotificationsResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteNotificationsResponse.
 * Use `create(DeleteNotificationsResponseSchema)` to create a new message.
 */
export const DeleteNotificationsResponseSchema: GenMessage<DeleteNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_notification, 11);

/**
 * @generated from enum gitpod.v1.NotificationType
 */
export enum NotificationType {
  /**
   * @generated from enum value: NOTIFICATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_AGENT_COMPLETED = 1;
   */
  AGENT_COMPLETED = 1,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_AGENT_WAITING_FOR_INPUT = 2;
   */
  AGENT_WAITING_FOR_INPUT = 2,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_ENVIRONMENT_ARCHIVED = 3;
   */
  ENVIRONMENT_ARCHIVED = 3,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_ENVIRONMENT_LIFETIME_EXCEEDED = 4;
   */
  ENVIRONMENT_LIFETIME_EXCEEDED = 4,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_BILLING_CREDITS_LOW = 5;
   */
  BILLING_CREDITS_LOW = 5,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_BILLING_PAYMENT_FAILED = 6;
   */
  BILLING_PAYMENT_FAILED = 6,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_BILLING_ACCOUNT_SUSPENDED = 7;
   */
  BILLING_ACCOUNT_SUSPENDED = 7,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_AUTOMATION_COMPLETED = 8;
   */
  AUTOMATION_COMPLETED = 8,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_AUTOMATION_STOPPED = 9;
   */
  AUTOMATION_STOPPED = 9,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_PREBUILD_FAILED = 10;
   */
  PREBUILD_FAILED = 10,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_USER_ADDED_TO_GROUP = 11;
   */
  USER_ADDED_TO_GROUP = 11,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_USER_REMOVED_FROM_GROUP = 12;
   */
  USER_REMOVED_FROM_GROUP = 12,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_PROJECT_SHARED_WITH_GROUP = 13;
   */
  PROJECT_SHARED_WITH_GROUP = 13,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_PROJECT_REMOVED_FROM_GROUP = 14;
   */
  PROJECT_REMOVED_FROM_GROUP = 14,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_USER_ADDED_TO_TEAM = 15;
   */
  USER_ADDED_TO_TEAM = 15,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_USER_REMOVED_FROM_TEAM = 16;
   */
  USER_REMOVED_FROM_TEAM = 16,
}

/**
 * Describes the enum gitpod.v1.NotificationType.
 */
export const NotificationTypeSchema: GenEnum<NotificationType> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_notification, 0);

/**
 * NotificationService manages in-app notifications for users.
 *
 * @generated from service gitpod.v1.NotificationService
 */
export const NotificationService: GenService<{
  /**
   * Lists notifications for the authenticated user.
   * Response includes unread_count and total_count for the inbox badge.
   *
   * ### Examples
   *
   * - List all notifications:
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - List unread notifications:
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   read: false
   *   ```
   *
   *
   * @generated from rpc gitpod.v1.NotificationService.ListNotifications
   */
  listNotifications: {
    methodKind: "unary";
    input: typeof ListNotificationsRequestSchema;
    output: typeof ListNotificationsResponseSchema;
  },
  /**
   * Returns a single notification by ID.
   *
   * ### Examples
   *
   * - Get notification:
   *
   *   ```yaml
   *   notificationId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   *
   * @generated from rpc gitpod.v1.NotificationService.GetNotification
   */
  getNotification: {
    methodKind: "unary";
    input: typeof GetNotificationRequestSchema;
    output: typeof GetNotificationResponseSchema;
  },
  /**
   * Marks notifications as read.
   *
   * ### Examples
   *
   * - Mark a single notification as read:
   *
   *   ```yaml
   *   notificationIds:
   *     - "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * - Mark multiple notifications as read:
   *
   *   ```yaml
   *   notificationIds:
   *     - "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *     - "a1b2c3d4-5e6f-7890-abcd-ef1234567890"
   *   ```
   *
   *
   * @generated from rpc gitpod.v1.NotificationService.MarkNotificationsRead
   */
  markNotificationsRead: {
    methodKind: "unary";
    input: typeof MarkNotificationsReadRequestSchema;
    output: typeof MarkNotificationsReadResponseSchema;
  },
  /**
   * Marks notifications as unread.
   *
   * ### Examples
   *
   * - Mark a single notification as unread:
   *
   *   ```yaml
   *   notificationIds:
   *     - "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * - Mark multiple notifications as unread:
   *
   *   ```yaml
   *   notificationIds:
   *     - "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *     - "a1b2c3d4-5e6f-7890-abcd-ef1234567890"
   *   ```
   *
   *
   * @generated from rpc gitpod.v1.NotificationService.MarkNotificationsUnread
   */
  markNotificationsUnread: {
    methodKind: "unary";
    input: typeof MarkNotificationsUnreadRequestSchema;
    output: typeof MarkNotificationsUnreadResponseSchema;
  },
  /**
   * Deletes notifications.
   *
   * ### Examples
   *
   * - Delete a single notification:
   *
   *   ```yaml
   *   notificationIds:
   *     - "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * - Delete multiple notifications:
   *
   *   ```yaml
   *   notificationIds:
   *     - "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *     - "a1b2c3d4-5e6f-7890-abcd-ef1234567890"
   *   ```
   *
   *
   * @generated from rpc gitpod.v1.NotificationService.DeleteNotifications
   */
  deleteNotifications: {
    methodKind: "unary";
    input: typeof DeleteNotificationsRequestSchema;
    output: typeof DeleteNotificationsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_notification, 0);

